import { Navigate, Outlet } from "react-router-dom";
import ApiService from "../Services/ApiServices";
import { useAuth } from "../../contexts/AuthContext";

const AuthRedirectRoute = () => {
    const { isAuthenticated, authLoading } = useAuth();

    if (authLoading) return <div>Loading...</div>;

    return isAuthenticated ? (
        <Navigate to="/my-profile" replace />
    ) : (
        <Outlet />
    );
};

export default AuthRedirectRoute;